export default __webpack_public_path__ + "static/media/padlock-locked.6ce624ec.svg";